import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import CreateProductModal from 'shared/components/CreateProductModal';
import CreateSupplierModal from 'shared/components/CreateSupplierModal';

const CreateSupplier = () => {
  const navigate = useNavigate();
  const handleNavigateHome = () => {
    navigate(-1);
  };
  const handleGoBack = () => {
    navigate(AppRoutes.SUPPLIER);
  };
  return (
    <div>
      <CreateSupplierModal
        showModalState={true}
        handleModalCancel={handleGoBack}
        handleModalConfirm={handleGoBack}
        id={2}
      />
      {/* <CreateProductModal
        handleModalCancel={handleNavigateHome}
        handleModalConfirm={handleNavigateHome}
        showModalState={true}
      /> */}
    </div>
  );
};

export default CreateSupplier;
